export default __webpack_public_path__ + "static/media/reward-3.de74c6c0.png";